@if (form && validationContext) {
  <rask-container-block [formGroup]="form">
    <div class="row">
      <rask-input
        class="col-2"
        label="Namn"
        [required]="true"
        formControlName="namn"
        [maxlength]="40"
        [rule]="validationContext.current.namn">
      </rask-input>
      <rask-selector
        formControlName="tradslagsgrupp"
        class="col-1"
        [reverseLookup]="false"
        label="Trädslag"
        [required]="true"
        [values]="tradslagItems"
        [rule]="validationContext.current.tradslagsgrupp"
        [viewFormatter]="tradslagViewFormatter"
        [viewSelectedFormatter]="tradslagViewSelectedFormatter"
        aid="tradslag">
      </rask-selector>
      <rask-selector
        formControlName="mottagningsplats"
        class="col-2"
        [reverseLookup]="true"
        label="Mottagningsplats"
        [values]="mottagningsplatsItems"
        [formatter]="mottagningsplatsFormatter"
        [viewFormatter]="mottagningsplatsViewFormatter"
        aid="mottagningsplats">
      </rask-selector>
      <rask-selector
        formControlName="mottagningsplatsViol3"
        class="col-2"
        [reverseLookup]="true"
        label="Mottagningsplats viol3"
        [values]="mottagningsplatsItemsViol3"
        [formatter]="mottagningsplatsFormatter"
        [viewFormatter]="mottagningsplatsViewFormatter"
        aid="mottagningsplatsviol3">
      </rask-selector>
      <rask-input
        class="col-2"
        label="Version"
        [required]="true"
        [rule]="validationContext.current.version"
        formControlName="version">
      </rask-input>
      <rask-input-number
        class="col-1"
        label="Max längd"
        unit="cm"
        [required]="true"
        [rule]="validationContext.current.maxlangd"
      formControlName="maxlangd"></rask-input-number>
      <rask-tree-selector
        class="col-2"
        label="Geografi"
        [autoSort]="true"
        [sortExpression]="regionerSortExpression"
        [items]="regionerItems"
        formControlName="regioner">
      </rask-tree-selector>
    </div>
    <div class="row">
      <rask-textarea
        class="col-2"
        label="Beskrivning"
        [rows]="8"
        [maxlength]="1000"
        formControlName="beskrivning">
      </rask-textarea>
      <rask-selector
        formControlName="produktgrupp"
        class="col-1"
        [reverseLookup]="true"
        label="Produktgrupp"
        [required]="true"
        [values]="produktgrupper"
        [rule]="validationContext.current.produktgrupp"
        aid="produktgrupper">
      </rask-selector>
      <rask-input
        class="col-2"
        label="Sortimentskod"
        formControlName="sortiment"
        [rule]="validationContext.current.sortimentskod">
      </rask-input>
      <div class="col-md-2">
        <div class="row">
          <rask-selector
            formControlName="handelssortiment"
            class="col-md-12"
            [reverseLookup]="true"
            label="Handelssortiment"
            [values]="handelssortimentList"
            [viewFormatter]="handelssortimentViewFormatter"
            [formatter]="handelssortimentFormatter"
            (change)="updateValidationMessages()"
            aid="handelssortiment">
          </rask-selector>
        </div>
        <div class="row">
          <rask-input
            class="col-12"
            label="Produkt"
            formControlName="produkt">
          </rask-input>
        </div>
      </div>
      <div class="col-md-2">
        <div class="row">
          <rask-input
            class="col-6"
            label="Skapad datum"
            formControlName="skapadDatum"
            [readonly]="true">
          </rask-input>
          <rask-input
            class="col-6"
            label="Ändrad datum"
            formControlName="andradDatum"
            [readonly]="true">
          </rask-input>
        </div>
        <div class="row">
          <rask-checkbox text="Produktinstruktion aktiv"
            [(ngModel)]="viewModel.produktinstruktionAktiv"
            [ngModelOptions]="{standalone: true}"
          [disabled]="true"></rask-checkbox>
        </div>
        <div class="row">
        </div>
      </div>
      <rask-input-number
        class="col-1"
        label="Max toppdiameter"
        unit="mm"
        [required]="true"
        [rule]="validationContext.current.maxdiameter"
      formControlName="maxdiameter"></rask-input-number>
      <div class="col-2">
        <rask-checkbox text="Enbart för simulering"
          formControlName="pinEnbartForSimulering"
          [disabled]="false"
        (checkedChange)="controlChanged($event)"></rask-checkbox>
        <rask-info>Produktinstruktion används enbart för att fånga volymer som annars missas vid
        utbytessimuleringarna per arbetsorder</rask-info>
      </div>
    </div>
    @if (validationMessages?.length > 0) {
      <div class="row">
        <rask-message-panel
          class="col-4"
          [numberOfItemsToDisplay]="3"
          [maxNumOfRows]="3"
          [labels]="messageLabels"
          [items]="validationMessages">
        </rask-message-panel>
      </div>
    }
  </rask-container-block>
}